
import icons from '@/assets/icons.js'

export default {
  name: 'SvgIcon',
  props: {
    name: {
      type: String,
      default: ''
    },
    size: {
      type: [String, Number],
      default: '24px'
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  },
  computed: {
    iconClass () {
      return `icon-${this.name}`
    },
    iconSvg () {
      return icons[this.name] || ''
    }
  }
}
